<template>
  <div class="flex flex-col min-h-screen bg-white">
    <AppHeader class="z-[101]" />
    <main class="flex-1 w-full">
      <!-- Без Transition тут. Анімація тепер у app.vue -->
      <slot />
      <GlobalLoader />
    </main>
    <AppFooter />
    <SpeedInsights />
  </div>
</template>

<script setup>
import AppHeader from "~/components/AppHeader.vue";
import AppFooter from "~/components/AppFooter.vue";
import GlobalLoader from "~/components/ui/GlobalLoader.vue";
import { SpeedInsights } from "@vercel/speed-insights/nuxt";
import { computed } from "vue";
import { useHead, useRoute, useRequestURL, useRuntimeConfig } from "#imports";

const route = useRoute();
const cfg = useRuntimeConfig();
const url = useRequestURL();

// Origin беремо з runtimeConfig, а НЕ з useRequestURL(): на Vercel запит
// приходить від внутрішнього проксі, тож origin там = http://localhost, і
// в сирому HTML проду canonical стояв `http://localhost/...` на кожній
// сторінці. У клієнті після гідрації значення виправлялось само, тому
// баг і жив непоміченим. siteUrl — те саме джерело, яким уже користуються
// sitemap і pillowcases. useRequestURL лишається запасним (dev-сервер).
const origin = String(cfg.public?.siteUrl || url.origin).replace(/\/$/, "");

// self-canonical без query (щоб /catalog?sort=... не індексувався як дубль)
const canonicalHref = computed(() => `${origin}${route.path}`);

useHead(() => ({
  link: [{ rel: "canonical", href: canonicalHref.value }],
}));
</script>

<style>
/* (необов'язково) можна видалити локальні .page-* якщо лишили в app.vue */
</style>
